<template>
<div >
    <linkbutton ref="startbutton" :toplabel="title" @click="Forgot()" />
    <!-- ACCT NOTE MODAL -->
      <actionmodal ref="mymodal" title="Forgot Password Modal" > 
        <template v-slot:body>
            <div >
                <form ref="changepassform" v-on:keyup.enter="SaveNewPassword">
                <h1 id="forgotpassword"><label class="titlelabel">{{title}}</label></h1>
                <label for="">* Required field</label>   
                <formentrystacked ref="oldpwd" inputid="old"  label="* School Email" v-model="emailaddress"  isrequired="True" autocomplete="email" @isshifttab="shifttaboninput($event)" />

                
                <br>

                <smallbutton ref="gobutton" @click="Go()" toplabel="Forgot Password" />
                <smallbutton ref="cancelbutton"    @click="close" toplabel='Cancel' buttonclass="button buttonhighlight" @istab="taboncancel($event)"  />
                
                </form>
            </div>
            <div>
                <label class="responsemessage">{{responseMessage}}</label>
            </div>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../services/datamethods.js'
import smallbutton from '../controls/button.vue'
import actionmodal from './actionmodal.vue'
import formentrystacked from '../controls/entry-stacked.vue'
import linkbutton from '../controls/linkbutton.vue'
export default {
    name:'forgotpassword',
    components:{
        smallbutton,
        actionmodal,
        formentrystacked,
        linkbutton
    },
    props:{
        title:{
            type:String,
            default:'Forgot Password'
        },
        username:{
            type:String,
        },

    },
    data(){
        return{
            emailaddress:'',
            responseMessage:null,
            trueParam:true
        }
    },

    methods:{
        taboncancel(event){
            console.log('tab2' + event)
            event.preventDefault()
            this.$nextTick(()=>{
                this.$refs.oldpwd.focus()
            });
        },
    
       
        shifttaboninput(event){
            console.log('shifttab on input' )
            event.preventDefault()
            this.$nextTick(()=>{
                this.$refs.cancelbutton.focus()
            });
        },
        Forgot(){
            this.emailaddress=this.username
            this.$refs.mymodal.openModal();
            this.$nextTick(()=>{
                this.$refs.oldpwd.focus()
            });
        },
        Go(){
            this.$emit('go',this.emailaddress)
            this.$refs.mymodal.closeModal()
        },
        close(){
            this.$refs.mymodal.closeModal()
            this.$nextTick(()=>{
                this.$refs.startbutton.focus()
            });
        }
        
    
    },
    mounted(){
        
        
    }
}
</script>

<style>

</style>

































       